export default __webpack_public_path__ + "static/media/flag-hr.073cf610.svg";